// extracted by mini-css-extract-plugin
export default {"wrap":"wrap-RPOy","body":"body-KDDT"};